import { Tooltip } from 'antd'
import { useContext } from 'react'

import BuildContext from 'src/context/buildContext'
import { APP_ENV } from 'src/env'
import BUILD_METADATA from 'src/metadata.json' with { type: 'json' }

const VERSION = `${BUILD_METADATA.buildMajor}.${BUILD_METADATA.buildMinor}.${BUILD_METADATA.buildRevision}`
const IS_PROD =
    APP_ENV.REACT_APP_ENVIRONMENT === 'production' ||
    APP_ENV.REACT_APP_ENVIRONMENT === 'v4'

const VersionInfo = () => {
    const { CURRENT_BUILD_TIME } = useContext(BuildContext)

    if (IS_PROD) {
        return <>v{VERSION}</>
    }

    return (
        <Tooltip title={`Last rebuild was ${CURRENT_BUILD_TIME.fromNow()}`}>
            <span className="cursor-pointer">v{VERSION}</span>
        </Tooltip>
    )
}

export default VersionInfo
